var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { BillingService2 } from "../billing.service";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { ChartParams } from "app/views/chart/chart.component";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { parseDate } from "app/lib/lib";
import { HelperService } from "app/lib/helper.service";
import merge from 'lodash-es/merge';
import { RefDetailComponent } from "../../views/referers/ref_detail.component";
import { RefService } from "../../views/referers/ref.service";
import { AlertComponent } from "../../views/modal/alert.component";
import { UserService } from "../../user/user.service";
import * as moment from 'moment-timezone';
var ConversionSourceComponent = /** @class */ (function (_super) {
    __extends(ConversionSourceComponent, _super);
    function ConversionSourceComponent(eventsService, service2, activatedRoute, translate, router, modalService, filter, http, helper, refService, route, userService) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.service2 = service2;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.refService = refService;
        _this.route = route;
        _this.userService = userService;
        _this.links = [];
        _this.totalLoader = false;
        _this.paginationLoader = false;
        _this.statsLoader = false;
        _this.chart = new ChartParams();
        _this.chart2 = new ChartParams();
        _this.chartSmallSource = new ChartParams();
        _this.tableChart = new ChartParams();
        _this.dontLoad = {};
        _this.rowNames = [];
        _this.columnNames = [];
        _this.baseUrl = _this.router.url.split('?')[0];
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTo', 'datePublished'],
            processorType: 'all',
            dateType: 'dateCreated',
            userRegType: 'usersWithSite',
            user21billingEnd: 21,
            year: moment().year(),
            period: 'month',
        };
        _this.years = [];
        _this.year = parseDate().year();
        _this.route.queryParams.subscribe(function (params) {
            _this.currentFP = params;
        });
        for (var yyyy = 2017; yyyy <= _this.year; yyyy++) {
            _this.years.unshift(yyyy);
        }
        _this.filter.addFilters.push('promocode');
        _this.chart2.setOptions({
            names: {
                pureConversion: 'Конверсия юзеров в платников'
            },
            axis: {
                y: {
                    show: true,
                    // max: 100,
                    label: {
                        text: 'Проценты',
                        position: 'outer-middle'
                    },
                    tick: {
                        format: function (y) {
                            return y + ' %';
                        }
                    }
                }
            },
        });
        _this.chart.setOptions({
            showLabels: ['Yandex Direct', 'Leshin trafic', 'Direct', 'Ucoz Main', 'Search organic', 'Google Adwords', 'affiliates.ukit.com']
        });
        return _this;
    }
    ConversionSourceComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.year = this.filter.filterParams.year || parseDate().year();
                        this.filter.filterParams.paginationDate = parseDate([this.year, 0, 1]).format('YYYY-MM-DD HH:mm:ss');
                        return [4 /*yield*/, this.getChart2()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getChart()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getTableChart()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getChartSmallSource()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.getChart2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, charts2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.chart2.showLoader();
                        return [4 /*yield*/, me.service2.conversionSource.chart(me.filter.getFilterParams(), 'charts2').toPromise()];
                    case 1:
                        charts2 = (_a.sent()).charts;
                        me.chart2.data = charts2;
                        me.chart2.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.chart.showLoader();
                        return [4 /*yield*/, me.service2.conversionSource.chart(me.filter.getCopyFilterParams({
                                chartType: 'conversion',
                            })).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.chart.data = charts;
                        me.chart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.getChartSmallSource = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.chartSmallSource.showLoader();
                        return [4 /*yield*/, me.service2.conversionSource.chartSmallSource(me.filter.getCopyFilterParams({
                                chartType: 'conversion',
                            }), 'chartSmallSource').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.chartSmallSource.data = charts;
                        me.chartSmallSource.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.getStats = function (fp) {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a, stats, rowNames, columnNames;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        return [4 /*yield*/, me.service2.conversionSource.stats(fp || me.filter.filterParams).toPromise()];
                    case 1:
                        _a = _b.sent(), stats = _a.stats, rowNames = _a.rowNames, columnNames = _a.columnNames;
                        me.statsLoader = false;
                        me.rowNames = rowNames;
                        me.columnNames = columnNames;
                        me.stats = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.userRegTypeChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.onClickByGroup = function (group) {
        return __awaiter(this, void 0, void 0, function () {
            var me, refGroup, fp, isUnGrouped, dateM, start, end, params, title, stats_1, i, subGroupCount, _a, stats, rowNames, columnNames;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        refGroup = group.rowName;
                        fp = me.filter.getCopyFilterParams();
                        isUnGrouped = me.refService.isUnGrouped(group.rowName);
                        if (!(group.parent || isUnGrouped)) return [3 /*break*/, 2];
                        dateM = parseDate(me.filter.filterParams.paginationDate);
                        start = dateM.format('DD-MM-YYYY');
                        end = dateM.endOf('year').format('DD-MM-YYYY');
                        params = merge({}, fp, {
                            reportType: 'reg_day',
                            dateFilterParams: {
                                dateCreated: {
                                    type: 'other',
                                    start: start,
                                    end: end,
                                }
                            },
                            dateType: 'dateCreated',
                        });
                        title = '';
                        // Тут и в "referers/ref.component.ts" идентичные по смыслу проверки.
                        if (isUnGrouped) {
                            params.refGroup = group.rowName;
                            title = group.rowName;
                        }
                        else {
                            params.refGroup = group.parent;
                            params.refSource = group.refGroup;
                            title = group.parent + " - " + refGroup;
                        }
                        group._isLoad = true;
                        return [4 /*yield*/, me.userService.reg_day.detail(params).toPromise()];
                    case 1:
                        stats_1 = (_b.sent()).stats;
                        group._isLoad = false;
                        this.modalService.open(RefDetailComponent, {
                            title: title,
                            stats: stats_1,
                        }, { size: 'hg' });
                        return [2 /*return*/];
                    case 2:
                        i = me.stats.findIndex(function (g) { return g.rowName === refGroup; });
                        subGroupCount = me.stats.reduce(function (c, s) { return c + (s.parent === refGroup ? 1 : 0); }, 0);
                        if (subGroupCount > 0) {
                            // close
                            me.stats.splice(i + 1, subGroupCount);
                            return [2 /*return*/];
                        }
                        group._isLoad = true;
                        // Тут избыточность в inGroup, пока так.
                        fp.refGroup = refGroup;
                        fp.inGroup = refGroup;
                        return [4 /*yield*/, me.service2.conversionSource.stats(fp).toPromise()];
                    case 3:
                        _a = _b.sent(), stats = _a.stats, rowNames = _a.rowNames, columnNames = _a.columnNames;
                        stats.forEach(function (s) { return s.parent = refGroup; });
                        me.stats = me.stats.slice(0, i + 1).concat(stats, me.stats.slice(i + 1));
                        console.log('showSource', group, { i: i, stats: stats, rowNames: rowNames, columnNames: columnNames });
                        group._isLoad = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.downloadStats = function () {
        window.location.href = this.service2.conversionSource.downloadFileRoute(this.filter.filterParams, 'csv');
        this.modalService.open(AlertComponent, {
            title: 'INFO',
            message: this.translate.__A('common.download file')
        });
    };
    ConversionSourceComponent.prototype.getQueryParams = function (p) {
        return merge({}, this.currentFP, __assign({}, p, { page: 1 }));
    };
    ConversionSourceComponent.prototype.getTooltipText = function (column) {
        return "100 * " + column.data.userPaidCount + " / " + column.data.userCount;
    };
    // TODO Вынести в pipe
    // ибо ангуля при каждом чихе будет дергать эту функцию для всех строк
    ConversionSourceComponent.prototype.getRowClass = function (group) {
        if (group.parent) {
            return '';
        }
        if (group.rowName === 'total') {
            return 'table-info';
        }
        if (this.refService.isUnGrouped(group.rowName)) {
            return 'table-warning';
        }
        return 'table-success';
    };
    // TODO Прикрыть delimeter, задержку ввода и чтобы срабатывало без потери фокуса
    ConversionSourceComponent.prototype.onChangeBillingEnd = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionSourceComponent.prototype.getTableChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.tableChart.showLoader();
                        return [4 /*yield*/, me.service2.conversionSource.chart(me.filter.getCopyFilterParams({
                                chartType: 'userCount',
                            })).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        me.tableChart.data = charts;
                        me.tableChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConversionSourceComponent;
}(BaseComponent));
export { ConversionSourceComponent };
